/**
 * Compliance date utilities
 * Shared logic for due date urgency calculation
 */

const CRITICAL_THRESHOLD_DAYS = 14;
const WARNING_THRESHOLD_DAYS = 30;

/**
 * Calculate the number of days until a due date (negative = overdue)
 */
export function daysUntilDate(dueDate: string): number {
  const now = new Date();
  const due = new Date(dueDate);
  return Math.ceil((due.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
}

/**
 * Determine urgency status based on days until due
 */
export function dueDateUrgency(dueDate: string): 'healthy' | 'warning' | 'critical' {
  const daysUntil = daysUntilDate(dueDate);
  if (daysUntil < CRITICAL_THRESHOLD_DAYS) return 'critical';
  if (daysUntil < WARNING_THRESHOLD_DAYS) return 'warning';
  return 'healthy';
}

/**
 * Human-readable label for days until due
 */
export function daysUntilLabel(dueDate: string): string {
  const daysUntil = daysUntilDate(dueDate);
  if (daysUntil < 0) return `${Math.abs(daysUntil)} days overdue`;
  if (daysUntil === 0) return 'Due today';
  if (daysUntil === 1) return 'Due tomorrow';
  return `${daysUntil} days until due`;
}
